import Vue from 'vue'
import Vuex from 'vuex'
import shortid from 'shortid'

Vue.use(Vuex)

export default function createStore (store = {}) {
  return new Vuex.Store({
    state: {
      entities: [],
      lastEntityUid: undefined,
      components: {},
      lastComponentUid: undefined,
      ...(store.state || {})
    },

    mutations: {
      resetEntities (state) {
        Vue.set(state, 'entities', [])
        state.lastEntityUid = undefined
      },

      resetComponents (state) {
        Vue.set(state, 'components', {})
        state.lastComponentUid = undefined
      },

      addEntity (state, entity) {
        const { entities, components } = state

        entity.uid = shortid.generate()

        // So we can lookup later
        state.lastEntityUid = entity.uid

        // Set components
        Vue.set(components, entity.uid, [])

        // Set entity
        entities.push(entity)
      },

      deleteEntity ({ entities, components }, entityUid) {
        // Delete entity
        const index = entities.findIndex((e) => e.uid === entityUid)
        if (index === -1) return

        entities.splice(index, 1)

        // Delete components
        Vue.delete(components, entityUid)
      },

      setEntity ({ entities }, entity) {
        const index = entities.findIndex((e) => e.uid === entity.uid)
        if (index === -1) return

        entities.splice(index, 1, entity)
      },

      addComponent (state, payload) {
        const components = state.components[payload.entityUid]

        payload.component.uid = shortid.generate()

        // So we can lookup later
        state.lastComponentUid = payload.component.uid

        // Add to store
        components.push(payload.component)
      },

      deleteComponent ({ components }, payload) {
        components = components[payload.entityUid]

        const index = components.findIndex((c) => c.uid === payload.componentUid)
        if (index === -1)

        components.splice(index, 1)
      },

      setComponent ({ components }, payload) {
        components = components[payload.entityUid]

        const index = components.findIndex((c) => c.uid === payload.component.uid)
        if (index === -1)

        components.splice(index, 1, payload.component)
      },

      ...(store.mutations || {})
    },

    actions: {
      resetState ({ commit }) {
        commit('resetEntities')
        commit('resetComponents')
      },

      addEntity ({ commit }, entity) {
        commit('addEntity', entity)
      },

      deleteEntity ({ commit }, entity) {
        commit('deleteEntity', entity)
      },

      setEntity ({ commit }, entity) {
        commit('setEntity', entity)
      },

      addComponent ({ commit }, payload) {
        commit('addComponent', payload)
      },

      deleteComponent ({ commit }, payload) {
        commit('deleteComponent', payload)
      },

      setComponent ({ commit }, payload) {
        commit('setComponent', payload)
      },

      addComponents ({ commit }, components) {
        // TODO
        components.reduce((acc, c) => {
          acc[c.uid] = commit('addComponent', c)
          return acc
        }, {})
      },

      deleteComponents ({ commit }, components) {
        // TODO
        components.reduce((acc, c) => {
          acc[c.uid] = commit('deleteComponent', c)
          return acc
        }, {})
      },

      setComponents ({ commit }, components) {
        // TODO
        components.reduce((acc, c) => {
          acc[c.uid] = commit('setComponent', c)
          return acc
        }, {})
      },

      ...(store.actions || {})
    },

    getters: {
      lastEntityUid (state) {
        return state.lastEntityUid
      },

      lastComponentUid (state) {
        return state.lastComponentUid
      },

      renderableEntities (state) {
        return state.entities
          .filter((e) => {
            const components = state.components[e.uid]
            const c = components.find((c) => c.kind === 'render')
            return c !== undefined
          })
      },

      ...(store.getters || {})
    }
  })
}
